(function () {
  'use strict';

  var QUIZ_SELECTOR = '[data-mq-quiz]';

  function initQuiz(root) {
    if (!root || root.dataset.mqInitialised === 'true') return;
    root.dataset.mqInitialised = 'true';

    var $ = function (sel) { return root.querySelector(sel); };

    // Quiz state
    var currentStep = 1;
    var unit = 'cm';
    var measurements = { length: '', height: '', width: '' };
    var result = null;

    // Step data
    var steps = [
      {
        title: 'Measuring Length',
        field: 'length',
        description: 'Measure from the waterline to the tip of the nose',
        image: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/nose_length.png?v=1750677443',
        dontsImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Donts_length.png?v=1761569803',
        video: 'https://cdn.shopify.com/videos/c/o/v/68d1fee3599f4fc695b28fdeb215a670.mp4',
        whyItMatters: {
          title: 'Why Length Matters',
          description: '<strong>Too Short:</strong> The nose presses against the end of the muzzle.<br><strong>Too Long:</strong> The muzzle pushes into the eyes when sniffing the ground.'
        }
      },
      {
        title: 'Measuring Height',
        field: 'height',
        description: 'Measure from in front of the eyes, straight down to the bottom of the jowl. Don\'t worry about pant room - we\'ll add that for you.',
        image: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/nose_height.png?v=1750677476',
        dontsImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Donts_height.png?v=1761569803',
        video: 'https://cdn.shopify.com/videos/c/o/v/ed26d7296856415fb6fab7b6e2115e4e.mp4',
        whyItMatters: {
          title: 'Why Height Matters',
          description: '<strong>Panting Space:</strong> Ensures the muzzle provides enough room below the jaw for your dog to pant fully. <strong>Panting is crucial</strong> for dogs to regulate their body temperature.'
        }
      },
      {
        title: 'Measuring Width',
        field: 'width',
        description: 'Measure the widest point of face, outside of cheek',
        image: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/nose_width.png?v=1750677475',
        dontsImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Donts_width.png?v=1761569803',
        video: 'https://cdn.shopify.com/videos/c/o/v/985916d81dfb40c8b3730aea9248b6d9.mp4',
        whyItMatters: {
          title: 'Why Width Matters',
          description: '<strong>Too Wide:</strong> If the muzzle is too wide, it may wobble as your dog moves, causing discomfort. <strong>Too Narrow:</strong> If the muzzle is too narrow, it may pinch the cheeks, leading to irritation or discomfort.'
        }
      }
    ];

    // Sizing data - matches the sizing chart (NO adjustments needed)
    var sizes = [
      { name: 'Mia', length: [5.0, 6.0], height: 10, width: [8.0, 9.0], productUrl: 'https://themuzzlemovement.com/products/size-mia-dog-muzzle-made-to-order-muzzle-with-colour-customisation-cbl', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Mia.png?v=1768560179' },
      { name: 'Mia*', length: [5.3, 6.3], height: 10, width: [8.0, 9.0], productUrl: 'https://themuzzlemovement.com/products/size-mia-dog-muzzle-made-to-order-muzzle-with-colour-customisation-cbl', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Mia.png?v=1768560179' },
      { name: 'Jimmy', length: [7.4, 8.4], height: 12, width: [9.0, 10.0], preorder: 'Pre-order — shipping March 2027', productUrl: 'https://themuzzlemovement.com/collections/customisable-muzzles/products/pre-order-size-jimmy-dog-muzzle-made-to-order-muzzle-with-colour-customisation-shipping-march-2027-cbl', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Jimmy_Quiz_Result_Image.png?v=1774532286' },
      { name: 'Jimmy*', length: [8.0, 9.0], height: 12, width: [9.0, 10.0], preorder: 'Pre-order — shipping March 2027', productUrl: 'https://themuzzlemovement.com/collections/customisable-muzzles/products/pre-order-size-jimmy-dog-muzzle-made-to-order-muzzle-with-colour-customisation-shipping-march-2027-cbl', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Jimmy_Quiz_Result_Image.png?v=1774532286' },
      { name: 'Rex', length: [8.5, 10.0], height: 13, width: [6.5, 8.5], productUrl: 'https://www.themuzzlemovement.com/products/size-rex', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Rex_de57225e-f3dd-4449-96bc-878602221fa6.png?v=1761571311' },
      { name: 'Rex*', length: [10.0, 11.5], height: 13, width: [6.5, 8.5], productUrl: 'https://www.themuzzlemovement.com/products/size-rex', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Rex_de57225e-f3dd-4449-96bc-878602221fa6.png?v=1761571311' },
      { name: 'Neli', length: [9.2, 10.7], height: 14, width: [7.3, 9.3], productUrl: 'https://www.themuzzlemovement.com/products/size-neli', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Neli_6fef9554-2a95-4916-ac3c-402fdfdb042f.png?v=1761571310' },
      { name: 'Neli*', length: [10.0, 11.5], height: 14, width: [7.3, 9.3], productUrl: 'https://www.themuzzlemovement.com/products/size-neli', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Neli_6fef9554-2a95-4916-ac3c-402fdfdb042f.png?v=1761571310' },
      { name: 'Tolly', length: [9.4, 10.9], height: 13, width: [9.3, 11.3], productUrl: 'https://www.themuzzlemovement.com/products/size-tolly', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Tolly_e3275d33-4b41-4ea4-8339-02b94f76ecc0.png?v=1761571311' },
      { name: 'Tolly*', length: [10.5, 12.0], height: 13, width: [9.3, 11.3], productUrl: 'https://www.themuzzlemovement.com/products/size-tolly', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Tolly_e3275d33-4b41-4ea4-8339-02b94f76ecc0.png?v=1761571311' },
      { name: 'Taz', length: [10.0, 11.5], height: 16.5, width: [10.0, 11.5], productUrl: 'https://www.themuzzlemovement.com/products/size-taz', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Taz_924174a4-fbf5-4fb9-a937-0a5e9d440ae3.png?v=1761571310' },
      { name: 'Taz*', length: [11.2, 12.7], height: 16.5, width: [10.0, 11.5], productUrl: 'https://www.themuzzlemovement.com/products/size-taz', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Taz_924174a4-fbf5-4fb9-a937-0a5e9d440ae3.png?v=1761571310' },
      { name: 'Sunny', length: [11.5, 13.0], height: 17.5, width: [13.0, 14.0], productUrl: 'https://www.themuzzlemovement.com/products/size-sunny', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Sunny_d75f91e2-53fe-41d7-97f5-7ad175465f23.png?v=1761571310' },
      { name: 'Sunny*', length: [13.2, 14.7], height: 17.5, width: [13.0, 14.0], productUrl: 'https://www.themuzzlemovement.com/products/size-sunny', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Sunny_d75f91e2-53fe-41d7-97f5-7ad175465f23.png?v=1761571310' },
      { name: 'Harry', length: [8.5, 9.5], height: 16, width: [14.0, 15.0], productUrl: 'https://www.themuzzlemovement.com/products/size-harry-version2', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Harry_811bcff8-456c-4249-9999-f2dbec87f580.png?v=1761571309' },
      { name: 'Harry*', length: [9.5, 10.6], height: 16, width: [14.0, 15.0], productUrl: 'https://www.themuzzlemovement.com/products/size-harry-version2', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Harry_811bcff8-456c-4249-9999-f2dbec87f580.png?v=1761571309' },
      { name: 'Mitzy', length: [9.5, 10.5], height: 20, width: [17.0, 18.0], productUrl: 'https://www.themuzzlemovement.com/products/mitzy-new-coming-soon', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Mitzy_68488739-9b14-4934-b07f-820bfd6f2316.png?v=1761571310' },
      { name: 'Mitzy*', length: [10.5, 11.5], height: 20, width: [17.0, 18.0], productUrl: 'https://www.themuzzlemovement.com/products/mitzy-new-coming-soon', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Mitzy_68488739-9b14-4934-b07f-820bfd6f2316.png?v=1761571310' },
      { name: 'Pippa', length: [6.7, 7.7], height: 15, width: [13.0, 14.0], productUrl: 'https://themuzzlemovement.com/products/size-pippa-dog-muzzle-made-to-order-muzzle-with-colour-customisation', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Pippa.png?v=1761571310' },
      { name: 'Pippa*', length: [8.0, 9.0], height: 15, width: [13.0, 14.0], productUrl: 'https://themuzzlemovement.com/products/size-pippa-dog-muzzle-made-to-order-muzzle-with-colour-customisation', productImage: 'https://cdn.shopify.com/s/files/1/0608/9801/7502/files/Pippa.png?v=1761571310' }
    ];

    var elements = {
      stepTitle: $('#mq-step-title'),
      stepDescription: $('#mq-step-description'),
      stepImage: $('#mq-step-image'),
      stepDontsImage: $('#mq-step-donts-image'),
      tutorialBtn: $('#mq-tutorial-btn'),
      cmBtn: $('#mq-cm-btn'),
      inchesBtn: $('#mq-inches-btn'),
      measurementInput: $('#mq-measurement-input'),
      inputUnit: $('#mq-input-unit'),
      backBtn: $('#mq-back-btn'),
      continueBtn: $('#mq-continue-btn'),
      infoTitle: $('#mq-info-title'),
      infoDescription: $('#mq-info-description'),
      quizSteps: $('#mq-quiz-steps'),
      quizResults: $('#mq-quiz-results'),
      resultContent: $('#mq-result-content'),
      startOverBtn: $('#mq-start-over-btn'),
      videoModal: $('#mq-video-modal'),
      modalClose: $('#mq-modal-close'),
      tutorialVideo: $('#mq-tutorial-video'),
      measurementWarning: $('#mq-measurement-warning')
    };

    function convertToCm(value, fromUnit) {
      return fromUnit === 'inches' ? value * 2.54 : value;
    }

    function updateProgressIndicator() {
      for (var i = 1; i <= 3; i++) {
        var stepIndicator = $('#mq-step-' + i + '-indicator');
        if (!stepIndicator) continue;
        if (i <= currentStep) {
          stepIndicator.classList.add('mq-active');
        } else {
          stepIndicator.classList.remove('mq-active');
        }
      }

      for (var j = 1; j <= 2; j++) {
        var line = $('#mq-line-' + j + '-' + (j + 1));
        if (!line) continue;
        if (j + 1 <= currentStep) {
          line.classList.add('mq-active');
        } else {
          line.classList.remove('mq-active');
        }
      }
    }

    function updateStepContent() {
      var step = steps[currentStep - 1];
      elements.stepTitle.textContent = step.title;
      elements.stepDescription.textContent = step.description;
      elements.stepImage.src = step.image;
      elements.stepImage.alt = step.title;
      elements.stepDontsImage.src = step.dontsImage;
      elements.stepDontsImage.alt = 'What not to do - ' + step.title;
      elements.infoTitle.textContent = step.whyItMatters.title;
      elements.infoDescription.innerHTML = step.whyItMatters.description;

      elements.measurementInput.value = measurements[step.field];

      if (currentStep > 1) {
        elements.backBtn.classList.remove('mq-hidden');
      } else {
        elements.backBtn.classList.add('mq-hidden');
      }

      elements.continueBtn.textContent = currentStep === 3 ? 'GET RESULT' : 'CONTINUE';
      updateContinueButton();
      updateMeasurementWarning();
    }

    function updateContinueButton() {
      var step = steps[currentStep - 1];
      elements.continueBtn.disabled = !measurements[step.field];
    }

        var HEIGHT_WARNING_THRESHOLD_CM = 25;

    function updateMeasurementWarning() {
      var warning = elements.measurementWarning;
      if (!warning) return;

      var step = steps[currentStep - 1];
      var value = parseFloat(measurements[step.field]);
      var isTooHigh = step.field === 'height' &&
                      !isNaN(value) &&
                      convertToCm(value, unit) > HEIGHT_WARNING_THRESHOLD_CM;

      if (isTooHigh) {
        warning.textContent = 'This seems very high. Make sure you\'re not adding the 7cm panting space on top of your measurement - we add that for you.';
        warning.classList.remove('mq-hidden');
      } else {
        warning.classList.add('mq-hidden');
      }
    }

    function findBestSize() {
      var lengthCm = convertToCm(parseFloat(measurements.length), unit);
      var heightCm = convertToCm(parseFloat(measurements.height), unit);
      var widthCm = convertToCm(parseFloat(measurements.width), unit);

      console.log('User measurements (cm):', { lengthCm: lengthCm, heightCm: heightCm, widthCm: widthCm });

      // Pant room groups
      var isMiaGroup = function (size) { return size.name.indexOf('Mia') !== -1; };
      var isRexJimmyGroup = function (size) { return size.name.indexOf('Rex') !== -1 || size.name.indexOf('Jimmy') !== -1; };
      var isStandardGroup = function (size) { return !isMiaGroup(size) && !isRexJimmyGroup(size); };

      function getPantRoom(size) {
        if (isMiaGroup(size)) return 3.5;
        if (isRexJimmyGroup(size)) return 5.5;
        return 7;
      }

      function isExactMatch(size) {
        var heightWithPantRoom = heightCm + getPantRoom(size);
        var lengthFits = lengthCm >= size.length[0] && lengthCm <= size.length[1];
        var heightFits = heightWithPantRoom <= size.height;
        var widthFits = widthCm >= size.width[0] && widthCm <= size.width[1];
        console.log('Checking ' + size.name + ' (' + getPantRoom(size) + 'cm pant):', {
          userHeight: heightCm,
          heightWithPant: heightWithPantRoom,
          lengthRange: size.length,
          maxHeight: size.height,
          widthRange: size.width,
          fits: { lengthFits: lengthFits, heightFits: heightFits, widthFits: widthFits }
        });
        return lengthFits && heightFits && widthFits;
      }

      function isCloseMatch(size) {
        var heightWithPantRoom = heightCm + getPantRoom(size);
        return lengthCm >= size.length[0] && lengthCm <= size.length[1] &&
               heightWithPantRoom > size.height && heightWithPantRoom <= size.height + 1 &&
               widthCm >= size.width[0] && widthCm <= size.width[1];
      }

      var noAsterisk = function (size) { return size.name.indexOf('*') === -1; };
      var hasAsterisk = function (size) { return size.name.indexOf('*') !== -1; };

      var passes = [
        { type: 'exact', test: isExactMatch },
        { type: 'close', test: isCloseMatch }
      ];
      var groups = [isMiaGroup, isStandardGroup, isRexJimmyGroup];
      var asteriskOrder = [noAsterisk, hasAsterisk];

      // Priority: Mia group, then standard group, then Rex/Jimmy group.
      // Within each: exact before close, non-asterisk before asterisk.
      for (var p = 0; p < passes.length; p++) {
        for (var g = 0; g < groups.length; g++) {
          for (var a = 0; a < asteriskOrder.length; a++) {
            var pass = passes[p];
            var inGroup = groups[g];
            var asteriskTest = asteriskOrder[a];
            var match = sizes.filter(function (size) {
              return inGroup(size) && asteriskTest(size) && pass.test(size);
            })[0];
            if (match) {
              console.log(pass.type + ' match found:', match.name);
              return { type: pass.type, size: match };
            }
          }
        }
      }

      console.log('No match found');
      return { type: 'none' };
    }

    function createConfetti() {
      var confettiCount = 80;
      var colors = ['', 'mq-color-1', 'mq-color-2', 'mq-color-3', 'mq-color-4', 'mq-color-5', 'mq-color-6'];

      for (var i = 0; i < confettiCount; i++) {
        var confetti = document.createElement('div');
        confetti.className = 'mq-confetti ' + colors[Math.floor(Math.random() * colors.length)];
        confetti.style.left = (Math.random() * 100) + '%';
        confetti.style.top = '-20px';

        var duration = 3 + Math.random() * 2;
        var delay = Math.random() * 1;
        var drift = (Math.random() - 0.5) * 150;

        confetti.style.animation = 'mq-confetti-fall ' + duration + 's ease-out ' + delay + 's forwards';
        confetti.style.transform = 'translateX(' + drift + 'px)';

        document.body.appendChild(confetti);

        (function (node, ms) {
          setTimeout(function () {
            if (node.parentNode) node.remove();
          }, ms);
        })(confetti, (duration + delay) * 1000 + 100);
      }
    }

    function sendToZapier(email) {
      console.log('📤 Sending quiz data to Zapier...');

      var quizData = {
        email: email,
        measurement_length: measurements.length,
        measurement_height: measurements.height,
        measurement_width: measurements.width,
        measurement_unit: unit,
        quiz_result_type: result.type
      };

      if (result.type === 'exact') {
        quizData.quiz_muzzle_size = result.size.name;
        quizData.product_url = result.size.productUrl;
        console.log('✅ Exact match - Size:', result.size.name);
      } else if (result.type === 'close') {
        quizData.close_to_size = result.size.name;
        quizData.product_url = result.size.productUrl;
        console.log('✅ Close match - Close to:', result.size.name);
      } else {
        console.log('✅ No match found');
      }

      var webhookUrl = 'https://hooks.zapier.com/hooks/catch/7430209/ust5yw0/';

      console.log('📊 Quiz data:', quizData);
      console.log('🔗 Webhook URL:', webhookUrl);

      var iframe = document.getElementById('mq-zapier-iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'mq-zapier-iframe';
        iframe.name = 'mq-zapier-iframe';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        console.log('✅ Created hidden iframe');
      }

      var form = document.createElement('form');
      form.method = 'POST';
      form.action = webhookUrl;
      form.target = 'mq-zapier-iframe';
      form.style.display = 'none';

      Object.keys(quizData).forEach(function (key) {
        if (quizData[key] !== undefined && quizData[key] !== null) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = quizData[key];
          form.appendChild(input);
        }
      });

      document.body.appendChild(form);

      console.log('📤 Submitting form to Zapier (in hidden iframe)...');
      form.submit();

      setTimeout(function () {
        console.log('✅ Form submitted to Zapier!');
        showSuccessMessage();
        form.remove();
      }, 500);
    }

    function showSuccessMessage() {
      var emailSection = $('.mq-klaviyo-form-section');
      if (!emailSection) return;

      var successMessage = '';

      if (result.type === 'exact') {
        successMessage =
          '<div style="text-align: center; padding: 2rem;">' +
            '<div style="font-size: 2rem; margin-bottom: 1rem;">✅</div>' +
            '<h3 style="color: #065f46; margin-bottom: 1rem;">Success!</h3>' +
            '<p style="color: #047857; margin-bottom: 1rem;">We\'ve sent your ' + result.size.name + ' sizing details to your email.</p>' +
            '<p style="color: #6b7280; font-size: 0.875rem;">You should receive them within a few minutes.</p>' +
          '</div>';
      } else if (result.type === 'close') {
        successMessage =
          '<div style="text-align: center; padding: 2rem;">' +
            '<div style="font-size: 2rem; margin-bottom: 1rem;">📩</div>' +
            '<h3 style="color: #92400e; margin-bottom: 1rem;">Thanks for subscribing!</h3>' +
            '<p style="color: #b45309; margin-bottom: 1rem;">We\'ll keep you updated on ' + result.size.name + ' and new size releases.</p>' +
            '<p style="color: #6b7280; font-size: 0.875rem;">Check your email for confirmation.</p>' +
          '</div>';
      } else {
        successMessage =
          '<div style="text-align: center; padding: 2rem;">' +
            '<div style="font-size: 2rem; margin-bottom: 1rem;">🔔</div>' +
            '<h3 style="color: #374151; margin-bottom: 1rem;">We\'ll be in touch!</h3>' +
            '<p style="color: #6b7280; margin-bottom: 1rem;">You\'ll be the first to know when we release new sizes.</p>' +
            '<p style="color: #6b7280; font-size: 0.875rem;">Thank you for your interest!</p>' +
          '</div>';
      }

      emailSection.innerHTML = successMessage;
    }

    function showErrorMessage() {
      var emailSection = $('.mq-klaviyo-form-section');
      if (!emailSection) return;
      emailSection.innerHTML =
        '<div style="text-align: center; padding: 2rem;">' +
          '<div style="font-size: 2rem; margin-bottom: 1rem;">⚠️</div>' +
          '<h3 style="color: #991b1b; margin-bottom: 1rem;">Oops!</h3>' +
          '<p style="color: #dc2626; margin-bottom: 1rem;">There was an issue submitting your information.</p>' +
          '<p style="color: #6b7280; font-size: 0.875rem;">Please try again or email us at support@themuzzlemovement.com</p>' +
        '</div>';
    }

    function setupEmailForm() {
      console.log('🔍 Setting up email form...');

      var attempts = 0;
      var maxAttempts = 20;

      var checkFormSection = setInterval(function () {
        attempts++;
        var formSection = $('.mq-klaviyo-form-section');

        if (formSection) {
          clearInterval(checkFormSection);
          console.log('✅ Form section found!');

          formSection.innerHTML =
            '<div class="mq-email-question">Would you like us to email you your sizing details?</div>' +
            '<input type="email" class="mq-email-input-new" id="mq-result-email" placeholder="Enter your email address" required>' +
            '<br>' +
            '<button class="mq-send-results-btn" id="mq-submit-email-btn">SEND ME MY RESULTS</button>' +
            '<div class="mq-privacy-text">By submitting, I confirm that I have read and agree to the privacy policy of this website and consent to receive future communications.</div>';

          var submitBtn = $('#mq-submit-email-btn');
          var emailInput = $('#mq-result-email');

          submitBtn.addEventListener('click', function () {
            var email = emailInput.value.trim();

            if (!email) {
              alert('Please enter your email address');
              return;
            }

            if (email.indexOf('@') === -1) {
              alert('Please enter a valid email address');
              return;
            }

            console.log('📧 Email entered:', email);
            submitBtn.disabled = true;
            submitBtn.textContent = 'SENDING...';

            sendToZapier(email);
          });

          emailInput.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') submitBtn.click();
          });

          console.log('✅ Email form setup complete!');
        } else if (attempts >= maxAttempts) {
          clearInterval(checkFormSection);
          console.warn('⚠️ Form section not found');
        }
      }, 500);
    }

    function showResults() {
      result = findBestSize();
      elements.quizSteps.classList.add('mq-hidden');
      elements.quizResults.classList.remove('mq-hidden');

      var resultHTML = '';
      var preorderNote = '';
      var ctaLabel = 'VIEW IN SHOP';

      if (result.size && result.size.preorder) {
        ctaLabel = 'PRE-ORDER NOW';
        preorderNote = '<div style="color: #6b7280; margin: 0.75rem 0 1.5rem; font-size: 0.875rem;">' + result.size.preorder + '</div>';
      }

      if (result.type === 'exact') {
        resultHTML =
          '<img src="' + result.size.productImage + '" alt="' + result.size.name + '" class="mq-result-product-image">' +
          '<div class="mq-result-header">It looks like the best muzzle size for your dog is:</div>' +
          '<div class="mq-result-size-name">' + result.size.name + '</div>' +
          '<a href="' + result.size.productUrl + '" class="mq-view-shop-btn">' + ctaLabel + '</a>' +
          preorderNote +
          '<a href="#" class="mq-go-back-btn" id="mq-go-back-link">GO BACK</a>' +
          '<div class="mq-klaviyo-form-section"></div>';

        setTimeout(createConfetti, 500);

      } else if (result.type === 'close') {
        resultHTML =
          '<img src="' + result.size.productImage + '" alt="' + result.size.name + '" class="mq-result-product-image">' +
          '<div class="mq-result-header">The best size for your dog may be:</div>' +
          '<div class="mq-result-size-name">' + result.size.name + '</div>' +
          '<a href="' + result.size.productUrl + '" class="mq-view-shop-btn">' + ctaLabel + '</a>' +
          preorderNote +
          '<a href="#" class="mq-go-back-btn" id="mq-go-back-link">GO BACK</a>' +
          '<div style="color: #6b7280; margin-bottom: 2rem; font-size: 0.875rem;">The majority of your measurements are inline with this size, but short of our suggested pant room by less than 1cm based on your height measurement.</div>' +
          '<div class="mq-klaviyo-form-section"></div>';

      } else {
        resultHTML =
          '<div class="mq-result-header">Unfortunately, we don\'t currently have a muzzle size that fits your dog\'s measurements.</div>' +
          '<div style="color: #6b7280; margin-bottom: 1.5rem;">Please leave your email and we\'ll notify you when new sizes become available.</div>' +
          '<div style="background-color: #fff5f3; border: 2px solid #FF9A82; border-radius: 0.5rem; padding: 1.5rem; margin-bottom: 1rem; text-align: left;">' +
            '<div style="font-weight: 500; color: #374151; margin-bottom: 0.75rem; font-size: 1.125rem;">Need help verifying your measurements?</div>' +
            '<div style="color: #6b7280; font-size: 0.875rem; line-height: 1.6; margin-bottom: 1rem;">' +
              'Our team can review your measurements and provide personalised feedback. Please email us at ' +
              '<a href="mailto:support@themuzzlemovement.com" style="color: #FF9A82; text-decoration: none; font-weight: 500;">support@themuzzlemovement.com</a> ' +
              'with photos of you taking each measurement, and we\'ll help ensure you get the perfect fit.' +
            '</div>' +
            '<a href="https://themuzzlemovement.com/pages/find-a-muzzle-fitter" target="_blank" class="mq-view-shop-btn" style="display: inline-block; margin-top: 0.5rem;">FIND A FITTER</a>' +
          '</div>' +
          '<a href="#" class="mq-go-back-btn" id="mq-go-back-link">GO BACK</a>' +
          '<div class="mq-klaviyo-form-section"></div>';
      }

      elements.resultContent.innerHTML = resultHTML;

      var goBackLink = $('#mq-go-back-link');
      goBackLink.addEventListener('click', function (e) {
        e.preventDefault();
        currentStep = 3;
        elements.quizResults.classList.add('mq-hidden');
        elements.quizSteps.classList.remove('mq-hidden');
        updateProgressIndicator();
        updateStepContent();
      });

      setupEmailForm();
    }

    function closeVideoModal() {
      elements.tutorialVideo.pause();
      elements.tutorialVideo.removeAttribute('src');
      elements.tutorialVideo.load();
      elements.videoModal.classList.add('mq-hidden');
    }

        // Event listeners
    elements.cmBtn.addEventListener('click', function () {
      unit = 'cm';
      elements.cmBtn.classList.add('mq-active');
      elements.inchesBtn.classList.remove('mq-active');
      elements.inputUnit.textContent = 'cm';
      updateMeasurementWarning();
    });

    elements.inchesBtn.addEventListener('click', function () {
      unit = 'inches';
      elements.inchesBtn.classList.add('mq-active');
      elements.cmBtn.classList.remove('mq-active');
      elements.inputUnit.textContent = 'inches';
      updateMeasurementWarning();
    });

    elements.measurementInput.addEventListener('input', function (e) {
      var step = steps[currentStep - 1];
      measurements[step.field] = e.target.value;
      updateContinueButton();
      updateMeasurementWarning();
    });

        elements.continueBtn.addEventListener('click', function () {
      if (currentStep < 3) {
        currentStep++;
        updateProgressIndicator();
        updateStepContent();
      } else {
        showResults();
      }
    });

    elements.backBtn.addEventListener('click', function () {
      if (currentStep > 1) {
        currentStep--;
        updateProgressIndicator();
        updateStepContent();
      }
    });

    elements.tutorialBtn.addEventListener('click', function () {
      var step = steps[currentStep - 1];
      elements.tutorialVideo.src = step.video;
      elements.videoModal.classList.remove('mq-hidden');
    });

    elements.modalClose.addEventListener('click', closeVideoModal);

    elements.videoModal.addEventListener('click', function (e) {
      if (e.target === elements.videoModal) closeVideoModal();
    });

    elements.startOverBtn.addEventListener('click', function () {
      currentStep = 1;
      measurements = { length: '', height: '', width: '' };
      result = null;

      elements.quizResults.classList.add('mq-hidden');
      elements.quizSteps.classList.remove('mq-hidden');

      updateProgressIndicator();
      updateStepContent();
    });

    // Initialise
    updateProgressIndicator();
    updateStepContent();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(QUIZ_SELECTOR).forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-initialise when Shopify re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();